import EventEmitter from 'events';
import TabNav from './ui/TabNav';

class PrimaryViewToggle extends EventEmitter {
  constructor(mode, isMultiMode = true) {
    super();
    this.mode = mode;

    this.tabNav = new TabNav('#tn-event-listing-mode-tab-nav', {
      mode: this.mode,
      onChange: this.onTabChange.bind(this),
    });

    if (isMultiMode) {
      this.tabNav.$nav.show();
    }
  }


  onTabChange(mode) {
    if (mode !== this.mode) {
      this.mode = mode;
      this.notify(mode);
    }
  }

  notify() {
    this.emit(PrimaryViewToggle.UPDATE, { mode: this.mode });
  }

}

PrimaryViewToggle.UPDATE = 'tnPrimaryViewToggle:update';

export default PrimaryViewToggle;
